module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 3);
}([function (e, t, n) {
  e.exports = n(4)();
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  (function () {
    (null !== t ? t : this).Lethargy = function () {
      function e(e, t, n, r) {
        this.stability = null != e ? Math.abs(e) : 8, this.sensitivity = null != t ? 1 + Math.abs(t) : 100, this.tolerance = null != n ? 1 + Math.abs(n) : 1.1, this.delay = null != r ? r : 150, this.lastUpDeltas = function () {
          var e, t, n;

          for (n = [], e = 1, t = 2 * this.stability; 1 <= t ? e <= t : e >= t; 1 <= t ? e++ : e--) {
            n.push(null);
          }

          return n;
        }.call(this), this.lastDownDeltas = function () {
          var e, t, n;

          for (n = [], e = 1, t = 2 * this.stability; 1 <= t ? e <= t : e >= t; 1 <= t ? e++ : e--) {
            n.push(null);
          }

          return n;
        }.call(this), this.deltasTimestamp = function () {
          var e, t, n;

          for (n = [], e = 1, t = 2 * this.stability; 1 <= t ? e <= t : e >= t; 1 <= t ? e++ : e--) {
            n.push(null);
          }

          return n;
        }.call(this);
      }

      return e.prototype.check = function (e) {
        var t;
        return null != (e = e.originalEvent || e).wheelDelta ? t = e.wheelDelta : null != e.deltaY ? t = -40 * e.deltaY : null == e.detail && 0 !== e.detail || (t = -40 * e.detail), this.deltasTimestamp.push(Date.now()), this.deltasTimestamp.shift(), t > 0 ? (this.lastUpDeltas.push(t), this.lastUpDeltas.shift(), this.isInertia(1)) : (this.lastDownDeltas.push(t), this.lastDownDeltas.shift(), this.isInertia(-1));
      }, e.prototype.isInertia = function (e) {
        var t, n, r, o, i, a, l;
        return null === (t = -1 === e ? this.lastDownDeltas : this.lastUpDeltas)[0] ? e : !(this.deltasTimestamp[2 * this.stability - 2] + this.delay > Date.now() && t[0] === t[2 * this.stability - 1]) && (r = t.slice(0, this.stability), n = t.slice(this.stability, 2 * this.stability), l = r.reduce(function (e, t) {
          return e + t;
        }), i = n.reduce(function (e, t) {
          return e + t;
        }), a = l / r.length, o = i / n.length, Math.abs(a) < Math.abs(o * this.tolerance) && this.sensitivity < Math.abs(o) && e);
      }, e.prototype.showLastUpDeltas = function () {
        return this.lastUpDeltas;
      }, e.prototype.showLastDownDeltas = function () {
        return this.lastDownDeltas;
      }, e;
    }();
  }).call(this);
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(1),
      o = n.n(r),
      i = n(0),
      a = n.n(i),
      l = n(2);

  function s() {
    return (s = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function u(e) {
    return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function c(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function f(e, t, n) {
    return (f = m() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && y(o, n.prototype), o;
    }).apply(null, arguments);
  }

  function p(e) {
    return function (e) {
      if (Array.isArray(e)) return d(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return d(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return d(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function d(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function h(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function y(e, t) {
    return (y = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function b(e, t) {
    return !t || "object" !== u(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function m() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function v(e) {
    return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var w = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && y(e, t);
    }(w, e);
    var t,
        n,
        r,
        i,
        a,
        d = (t = w, n = m(), function () {
      var e,
          r = v(t);

      if (n) {
        var o = v(this).constructor;
        e = Reflect.construct(r, arguments, o);
      } else e = r.apply(this, arguments);

      return b(this, e);
    });

    function w(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, w), (t = d.call(this, e)).componentDidMount = function () {
        t.props.disableKeyboard || document.addEventListener("keydown", t.handleKeyPress, {
          passive: !0
        }), t.containerRef.current && t.containerRef.current.addEventListener("wheel", t.handleWheelScroll, {
          passive: !1
        });
      }, t.componentWillUnmount = function () {
        t.props.disableKeyboard || document.removeEventListener("keydown", t.handleKeyPress, {
          passive: !0
        }), t.containerRef.current && t.containerRef.current.removeEventListener("wheel", t.handleWheelScroll), t.timer && clearTimeout(t.timer);
      }, t.startTimeout = function () {
        var e = t.props.timeout;
        t.onTimeout = !0, t.timer = setTimeout(function () {
          t.onTimeout = !1, t.firedEvent = !1;
        }, e);
      }, t.handleWheelScroll = function (e) {
        e.stopPropagation(), t.props.preventScroll && e.preventDefault();
        var n = t.props,
            r = n.pauseListeners,
            o = n.timeout,
            i = n.upHandler,
            a = n.downHandler,
            l = t.Lethargy.check(e);
        if (!1 !== l && !t.firedEvent && !r) return t.firedEvent = !0, o && t.startTimeout(), l > 0 ? void (i && i(e)) : void (l < 0 && a && a(e));
        r || o && t.onTimeout || (t.firedEvent = !1);
      }, t.handleKeyPress = function (e) {
        var n = t.props,
            r = n.upHandler,
            o = n.downHandler,
            i = n.leftHandler,
            a = n.rightHandler,
            l = n.timeout;
        n.pauseListeners || t.onTimeout || (38 === e.keyCode && (r && r(), l && t.startTimeout()), 37 === e.keyCode && (a && a(), l && t.startTimeout()), 39 === e.keyCode && (i && i(), l && t.startTimeout()), 40 === e.keyCode && (o && o(), l && t.startTimeout()));
      }, t.unify = function (e) {
        return e.changedTouches ? e.changedTouches[0] : e;
      }, t.handleSwipeStart = function (e) {
        t.startX = t.unify(e).clientX, t.startY = t.unify(e).clientY;
      }, t.sign = function (e) {
        return e ? e < 0 ? -1 : 1 : 0;
      }, t.handleSwipeEnd = function (e) {
        var n = t.props,
            r = n.leftHandler,
            o = n.rightHandler,
            i = n.upHandler,
            a = n.downHandler,
            l = n.timeout,
            s = n.pauseListeners,
            u = 0,
            c = 0;

        if (!t.onTimeout && !s) {
          if ((t.startX || 0 === t.startX) && (u = t.unify(e).clientX - t.startX), (t.startY || 0 === t.startY) && (c = t.unify(e).clientY - t.startY), Math.abs(u) > Math.abs(c)) {
            var f = t.sign(u);
            f < 0 && r && r(), f > 0 && o && o();
          } else {
            var p = t.sign(c);
            p < 0 && a && a(), p > 0 && i && i();
          }

          l && t.startTimeout(), t.startY = null, t.startX = null;
        }
      }, t.firedEvent = !1, t.onTimeout = !1, t.Lethargy = f(l.Lethargy, p(t.props.wheelConfig)), t.containerRef = o.a.createRef(), t;
    }

    return r = w, (i = [{
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.CustomComponent,
            n = e.children,
            r = (e.upHandler, e.downHandler, e.leftHandler, e.rightHandler, e.pauseListeners, e.disableKeyboard, e.preventScroll, e.wheelConfig, e.disableSwipe),
            i = e.disableSwipeWithMouse,
            a = c(e, ["CustomComponent", "children", "upHandler", "downHandler", "leftHandler", "rightHandler", "pauseListeners", "disableKeyboard", "preventScroll", "wheelConfig", "disableSwipe", "disableSwipeWithMouse"]),
            l = r ? null : this.handleSwipeStart,
            f = r ? null : this.handleSwipeEnd,
            p = {
          onKeyPress: this.handleKeyPress,
          tabIndex: "0",
          onTouchStart: l,
          onMouseDown: i ? null : l,
          onMouseUp: i ? null : f,
          onTouchEnd: f,
          ref: this.containerRef
        };
        return "object" === u(t) ? o.a.createElement(t, s({}, a, p), n) : o.a.createElement("div", s({}, a, p), n);
      }
    }]) && h(r.prototype, i), a && h(r, a), w;
  }(r.Component);

  w.propTypes = {
    upHandler: a.a.func,
    downHandler: a.a.func,
    leftHandler: a.a.func,
    rightHandler: a.a.func,
    CustomComponent: a.a.object,
    pauseListeners: a.a.bool.isRequired,
    timeout: a.a.number,
    disableKeyboard: a.a.bool.isRequired,
    disableSwipe: a.a.bool.isRequired,
    disableSwipeWithMouse: a.a.bool.isRequired,
    preventScroll: a.a.bool.isRequired,
    wheelConfig: a.a.array
  }, w.defaultProps = {
    pauseListeners: !1,
    timeout: 700,
    disableKeyboard: !1,
    disableSwipe: !1,
    disableSwipeWithMouse: !1,
    preventScroll: !1,
    wheelConfig: []
  }, t.default = w;
}, function (e, t, n) {
  "use strict";

  var r = n(5);

  function o() {}

  e.exports = function () {
    function e(e, t, n, o, i, a) {
      if (a !== r) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return n.checkPropTypes = o, n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}]);